module.exports = __webpack_public_path__ + "img/grid-img.jpg";